<div>
  <div class="need-to-know-container">
    <h2 class="title">Things you need to know</h2>
    <div class="desc">
      <div [innerHTML]="content"></div>
    </div>
  </div>
</div>
